// Returns the ISO week of the date.
function Week(self) {
    var date = new Date(self.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return (1 +
        Math.round(((date.getTime() - week1.getTime()) / 86400000 -
            3 +
            ((week1.getDay() + 6) % 7)) /
            7));
}
// Returns the four-digit year corresponding to the ISO week of the date.
function Year(self) {
    var date = new Date(self.getTime());
    date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
    return date.getFullYear();
}
function WeekYear(self) {
    var dayOfTheWeek = (self.getDay() + 6) % 7;
    return {
        week: Week(self),
        year: Year(self),
        dayOfTheWeek: dayOfTheWeek,
    };
}
function DayYear(now) {
    var start = new Date(now.getFullYear(), 0, 0);
    var diff = now.getTime() - start.getTime();
    var oneDay = 1000 * 60 * 60 * 24;
    var day = Math.floor(diff / oneDay);
    var year = now.getFullYear();
    return { day: day, year: year };
}
export { WeekYear, DayYear };
